// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert__KD9jK","message":"message__3UpwH","fade-in":"fade-in__UkOo8","button":"button__TTowo"};